import React, { useRef, useState } from "react";
import * as styles from "./home-book.module.scss";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import { useTranslation } from "react-i18next";

gsap.registerPlugin(ScrollTrigger);

export const HomeBook = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation();

  useGSAP(
    () => {
      const images: HTMLDivElement[] = gsap.utils.toArray(
        `.${styles.book__imgsEl}`,
        containerRef.current
      );

      images.forEach((el) => {
        const parallaxValue = parseFloat(
          getComputedStyle(el).getPropertyValue("--gsap-parallax") || "50"
        );

        gsap.to(el, {
          y: `-${parallaxValue}px`,
          ease: "none",
          scrollTrigger: {
            trigger: el.closest(`.${styles.book__imgsItem}`),
            start: "top bottom",
            end: "bottom top",
            scrub: 1,
          },
        });
      });
    },
    { dependencies: [], scope: containerRef }
  );

  return (
    <section className={styles.book} ref={containerRef}>
      <div className={styles.book__wrapp}>
        <div className={styles.book__imgs}>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num, i) => (
            <div
              key={i}
              className={`${styles.book__imgsItem} ${
                styles[`book__imgs${num}`]
              }`}
            >
              <div className={styles.book__imgsEl}>
                <img src={`/images/home-page/book${num}.jpg`} alt={`${num}`} />
              </div>
            </div>
          ))}
        </div>

        {/* <a href="tel:+48883341617" className={styles.book__link}>
          <div className={styles.book__linkImg}>
            <img src="/images/home-page/book-btn.svg" alt="img" />
          </div>
          <div className={styles.book__txt}>{t("header.book_table")}</div>
        </a> */}
      </div>
    </section>
  );
};
